import { createBrowserHistory } from "history";

/**
 * Historial de navegacion
 */
export const AppHistory = createBrowserHistory();

// urls con versión en ingles y español
const LOCALIZED_BASES = [
    "/libros",
	"/que-es",
	"/que-es/colegios",
	"/que-es/bibliotecas",
	"/que-es/loggedin",
	"/contacto",
	"/contacto/cita",
	"/contacto/demo",
];

/**
 * Determina si la url debe ser localizada
 */
function shouldLocalize(path) {
	return LOCALIZED_BASES.some((base) => path === base || path.startsWith(base + "/"));
}

/**
 * Asegura que la url comience con una barra
 */
function ensureLeadingSlash(p) {
	return p.startsWith("/") ? p : `/${p}`;
}

/**
 * Localiza la url si es necesario ( concatena la url en inglés si la url actual no es inglés )
 */
function localizeIfNeeded(path, locationState) {
	// Skip localization ( solo se usa por el momento cuando se hace el cambio manual de lenguaje en el dropdown)
	if (locationState && locationState.__skipLocale) return ensureLeadingSlash(path);

	const currentIsEn =
		AppHistory.location.pathname === "/en" || AppHistory.location.pathname.startsWith("/en/");

	if (!currentIsEn) return ensureLeadingSlash(path);

	const normalized = ensureLeadingSlash(path);

	if (normalized === "/en" || normalized.startsWith("/en/")) return normalized;

	if (!shouldLocalize(normalized)) return normalized;

	return `/en${normalized}`;
}

const originalPush = AppHistory.push;
const originalReplace = AppHistory.replace;

// sobreescribe las funciones push y replace
AppHistory.push = function (to, state) {
	if (typeof to === "string") {
		return originalPush.call(this, localizeIfNeeded(to, state), state);
	}
	if (to && typeof to === "object" && typeof to.pathname === "string") {
		return originalPush.call(
			this,
			{ ...to, pathname: localizeIfNeeded(to.pathname, to.state) },
			state,
		);
	}
	return originalPush.call(this, to, state);
};

AppHistory.replace = function (to, state) {
	if (typeof to === "string") {
		return originalReplace.call(this, localizeIfNeeded(to, state), state);
	}
	if (to && typeof to === "object" && typeof to.pathname === "string") {
		return originalReplace.call(
			this,
			{ ...to, pathname: localizeIfNeeded(to.pathname, to.state) },
			state,
		);
	}
	return originalReplace.call(this, to, state);
};
